import AIDeveloperImage from "../../images/ai-developers.webp";
export const careerAssets = {
  jobDetails: {
    translate: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/job-details/translate.svg`,
    location: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/job-details/location.svg`,
    department: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/job-details/department.svg`,
    time: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/job-details/time.svg`,
    experience: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/job-details/experience.svg`,
    job: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/job-details/job.svg`,
  },
  career: {
    logoStamp: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/career/logo-stamp.svg`,
    phoneFill: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/career/phone-fill.svg`,
    mail: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/career/uiw_mail.svg`,
    arrow: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/career-arrow.svg`,
    floatingText: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/career/floating-text.png`,
    image1: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/career/1.jpg`,
    image2: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/career/2.jpg`,
    image3: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/career/3.jpg`,
    image4: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/career/4.jpg`,
    image5: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/career/5.jpg`,
    image6: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/career/6.jpg`,
    image7: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/career/7.jpg`,
    brand: {
      brand1: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/career/brand/brand1.png`,
      brand2: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/career/brand/brand2.png`,
      brand3: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/career/brand/brand3.png`,
      brand4: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/career/brand/brand4.png`,
      brand5: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/career/brand/brand5.png`,
      brand6: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/career/brand/brand6.png`,
      brand7: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/career/brand/brand7.png`,
      brand8: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/career/brand/brand8.png`,
      brand9: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/career/brand/brand9.png`,
      brand10: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/career/brand/brand10.png`,
    },
    events: {
      event1: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/career/events/event1.jpg`,
      event2: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/career/events/event2.jpg`,
    },
    podcast: {
      play: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/career/podcast/play.svg`,
      pause: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/career/podcast/pause.svg`,
      sign1: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/career/podcast/sign1.png`,
      sign2: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/career/podcast/sign2.png`,
      podcast1: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/career/podcast/podcast1.jpg`,
      podcast2: AIDeveloperImage,
      podcastBottomBg: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/career/podcast/podcast-bottom-bg.jpg`,
    },
    process: {
      step1: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/career/process/step1.svg`,
      step2: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/career/process/step2.svg`,
      step3: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/career/process/step3.svg`,
    },
  },
};
